


















import { dateTimeToPtBrFormat } from '@/shareds/date/date-utils'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { EditarUmaVendaUseCase, FindCanalDeVendasUseCase} from '@/usecases'
import DatePicker from '@/components/ui/DatePicker.vue'
import { Component, Prop, Vue } from 'vue-property-decorator'
import type { CanaldeVendas } from '@/models'

@Component({
	components: {
		DatePicker,
	},
})
export default class DialogoDeEdicaoDoCanalDeVendas extends Vue {
	@Prop({ type: String }) idDaVenda?: string
	@Prop({ type: Object }) canalDeVendas?: CanaldeVendas

	findCanalDeVendasUseCase = new FindCanalDeVendasUseCase()
	editarUmaVendaUseCase = new EditarUmaVendaUseCase()

	canalSelecionado: CanaldeVendas | null = null
	canaisDeVendas: CanaldeVendas[] = []
	salvando = false
	mostra = false

	dateTimeToPtBrFormat = dateTimeToPtBrFormat

	created() {
		this.carregarCanaisDeVendas()
	}

	async carregarCanaisDeVendas() {
		try {
			const pagina = await this.findCanalDeVendasUseCase.findAll({}, {})
			this.canaisDeVendas = pagina.content
		} catch (error: any) {
			AlertModule.setError(error)
		}
	}

	mostrar() {
		this.canalSelecionado = this.canalDeVendas || null
		this.mostra = true
	}

	async confirmar() {
		if (!this.idDaVenda) {
			this.mostra = false
			return
		}

		try {
			this.salvando = true
			
			await this.editarUmaVendaUseCase.patchCanalDeVendas(this.idDaVenda, this.canalSelecionado?.id || '')

			this.$emit('atualizarCanalDeVendas', this.canalSelecionado)
			AlertModule.setSuccess('Canal de Vendas atualizado com sucesso')
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.salvando = false
		}
		this.mostra = false
	}
}
